import { useAuditLog, type AuditLogEntry } from '../../api/queries.js';
import { useAuthStore } from '../../auth/auth-store.js';
import {
  type Column,
  DataTable,
  IconButton,
  PageHeader,
  formatDateTime,
} from '../../components/ui/index.js';

const CAT_COLORS: Record<string, string> = {
  auth: 'info',
  ticket: 'success',
  admin: 'warning',
  security: 'danger',
  channel: 'info',
  bot: 'info',
  widget: 'info',
  billing: 'warning',
  gdpr: 'warning',
  system: 'default',
};

export function SettingsAuditLog(): JSX.Element {
  const user = useAuthStore((s) => s.user);
  const slug = user?.workspaceSlug;
  const auditQ = useAuditLog(slug);
  const items = auditQ.data?.items ?? [];

  const columns: Column<AuditLogEntry>[] = [
    {
      key: 'time',
      label: 'Время',
      width: 160,
      render: (r) => (
        <span style={{ fontFamily: 'var(--inbx-font-mono)', fontSize: 'var(--inbx-fz-sm)' }}>
          {formatDateTime(r.occurredAt)}
        </span>
      ),
    },
    {
      key: 'actor',
      label: 'Оператор',
      width: 130,
      render: (r) => (
        <span style={{ fontSize: 'var(--inbx-fz-sm)' }}>{r.actorUserId?.slice(0, 8) ?? '—'}…</span>
      ),
    },
    {
      key: 'ip',
      label: 'IP',
      width: 120,
      render: (r) => (
        <span style={{ fontFamily: 'var(--inbx-font-mono)', fontSize: 'var(--inbx-fz-sm)' }}>
          {r.actorIp ?? '—'}
        </span>
      ),
    },
    {
      key: 'cat',
      label: 'Категория',
      width: 140,
      render: (r) => (
        <span className={`inbx-pill-badge inbx-pill-badge--${CAT_COLORS[r.category] ?? 'default'}`}>
          {r.category}
        </span>
      ),
    },
    { key: 'event', label: 'Событие', render: (r) => <span>{r.eventType}</span> },
    {
      key: 'resource',
      label: 'Ресурс',
      width: 180,
      render: (r) => (r.resourceType ? `${r.resourceType}: ${r.resourceId?.slice(0, 8)}…` : '—'),
    },
  ];

  return (
    <div className="inbx-page">
      <PageHeader
        title="Журнал аудита"
        actions={<IconButton icon="ti-download" tooltip="Экспорт" />}
      />
      <div className="inbx-page__body" style={{ padding: 0 }}>
        <DataTable rows={items} columns={columns} loading={auditQ.isLoading} />
      </div>
    </div>
  );
}
